
define('text!fusion/ui/controls/fusion-chartjs.html',[],function () { return '<div>\r\n    <canvas class="chartjs-container"></canvas>\r\n</div>';});

